module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isManager('project|management|finance') && _vm.rowData.count == 0 || _vm.isSuper()) ? _c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31761c2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backhaul/BackhaulControls.vue
// module id = 1479
// module chunks = 0